import { CustomFieldTypeIcon } from 'v5/patterns/widgets/customFieldTypeIcons';
import { CustomFieldDefinition } from '__types__';
import { FilterBooleanConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createBooleanFilterConfig(
  customFieldDef: CustomFieldDefinition
): FilterBooleanConfig {
  return {
    label: customFieldDef.name,
    icon: <CustomFieldTypeIcon type={customFieldDef.data_type} />,
    type: 'boolean' as const,
    createDefaultValue: () => ({ operator: 'equal', value: false }),
    options: {
      valueLabel: 'True',
      subjectLabel: customFieldDef.name
    }
  };
}
